import styled from 'styled-components';
import { ReactComponent as CloseSvg } from '../../assets/icons/close.svg';

export const CloseIconWrapper = styled.div`
  height: 100%;
  width: 24px;
  position: absolute;
  transition: opacity 0.3s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;

export const CloseIcon = styled(CloseSvg)``;

export const SearchFilter = styled.div`
  display: flex;
  height: 3.6rem;
  padding: 0 0.8rem;
  align-items: center;
  border-radius: 100px;
  background: #313134;
  cursor: ${props => (props.$expanded ? 'default' : 'pointer')};
  width: ${props => (props.$expanded ? '25rem' : '3.6rem')};
  min-width: ${props => (props.$expanded ? '25rem' : '3.6rem')};
  transition:
    width 0.6s cubic-bezier(0.23, 1, 0.32, 1),
    min-width 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  position: relative;
`;

export const StyledInput = styled.input`
  background-color: transparent;
  width: 100%;
  border: none;
  outline: none;
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.07px;
  padding-left: 30px;
  z-index: 2;

  &::placeholder {
    color: #fff;
  }
`;
